import React from 'react';
import { HomeIcon, BuildingOfficeIcon, BuildingOffice2Icon, CheckIcon } from '@heroicons/react/24/outline';
import { Container } from '../common/Container';
import { Card } from '../common/Card';

const propertyTypes = [
  {
    Icon: HomeIcon,
    title: 'Residential Properties',
    description: 'Comprehensive appeal solutions for single-family homes, multi-family properties, and residential portfolios.',
    features: [
      'Single-family homes',
      'Multi-family properties',
      'Residential portfolios',
      'HOA management'
    ]
  },
  {
    Icon: BuildingOfficeIcon,
    title: 'Commercial Properties',
    description: 'Enterprise-grade tools for office buildings, retail centers, and industrial properties.',
    features: [
      'Office buildings',
      'Retail centers',
      'Industrial properties',
      'Mixed-use developments'
    ]
  },
  {
    Icon: BuildingOffice2Icon,
    title: 'Condominiums',
    description: 'Specialized solutions for condominium complexes with unit-level and common area valuations.',
    features: [
      'Unit-level appeals',
      'Common area valuations',
      'HOA integration',
      'Bulk processing'
    ]
  }
];

export const PropertyTypes: React.FC = () => {
  return (
    <section className="py-24 bg-white">
      <Container>
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-brand-blue mb-4">
            Solutions for Every Property Type
          </h2>
          <p className="text-xl text-brand-white-600 max-w-3xl mx-auto">
            Whether you're managing residential homes, commercial portfolios, or 
            condominium complexes, Appeal Advantage has you covered.
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {propertyTypes.map((type, index) => (
            <Card key={index} hover>
              <div className="w-14 h-14 bg-brand-blue rounded-lg flex items-center justify-center mb-6">
                <type.Icon className="w-8 h-8 text-white" />
              </div>
              
              <h3 className="text-2xl font-bold text-brand-blue mb-3">
                {type.title}
              </h3>
              
              <p className="text-brand-white-700 mb-6">
                {type.description}
              </p>
              
              <ul className="space-y-2 mb-6">
                {type.features.map((feature, i) => (
                  <li key={i} className="flex items-start">
                    <CheckIcon className="w-5 h-5 text-brand-red mr-2 mt-0.5 flex-shrink-0" />
                    <span className="text-brand-white-700">{feature}</span>
                  </li>
                ))}
              </ul>
              
              <button className="text-brand-blue font-semibold hover:text-brand-red transition-colors">
                Learn More →
              </button>
            </Card>
          ))}
        </div>
      </Container>
    </section>
  );
};

